import { giphyDarkGrey } from '@giphy/js-brand'
import { CSSProperties, ForwardedRef, forwardRef, isValidElement, ReactNode, SyntheticEvent } from 'react'
import { ControlSize, Gradient } from 'types'
import { Button as ButtonComponent, Icon, Label } from './style'

export type ButtonProps = {
    children?: ReactNode
    className?: string
    color?: string
    disabled?: boolean
    gradient?: Gradient
    href?: string
    icon?: ReactNode
    iconLocation?: 'left' | 'right'
    role?: string
    roleDescription?: string
    size?: ControlSize
    style?: CSSProperties
    tabIndex?: number
    textColor?: string
    title?: string
    onClick?: (e: SyntheticEvent<HTMLButtonElement, Event>) => void
}

const Button = (
    {
        children,
        color = giphyDarkGrey,
        gradient,
        href,
        icon,
        iconLocation = 'right',
        size = 'small',
        textColor,
        ...rest
    }: ButtonProps,
    ref: ForwardedRef<any>
) => (
    <ButtonComponent
        {...rest}
        as={href ? 'a' : 'button'}
        controlColor={color}
        controlSize={size}
        gradient={gradient}
        href={href}
        ref={ref}
        textColor={textColor}
        type={href ? undefined : 'button'}
    >
        {icon && iconLocation === 'left' && <Icon>{icon}</Icon>}
        {children && (isValidElement(children) ? children : <Label>{children}</Label>)}
        {icon && iconLocation === 'right' && <Icon>{icon}</Icon>}
    </ButtonComponent>
)

export default forwardRef(Button)
